"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroSubsidyItem = exports.SubsidyDetails = exports.SubsidyYears = void 0;
exports.SubsidyYears = [2021, 2022, 2023, 2024, 2025];
class SubsidyDetails {
    constructor(subsidyPerAmount, amount) {
        this.subsidyPerAmount = subsidyPerAmount;
        this.amount = amount;
    }
    subsidy(product) {
        if (product?.subsidy != null)
            return product.subsidy; // product.subsidy may be 0, but not null or undefined
        if (typeof this.subsidyPerAmount === 'number')
            return this.subsidyPerAmount;
        return this.subsidyPerAmount(product);
    }
}
exports.SubsidyDetails = SubsidyDetails;
/** A {@link ZeroSubsidyItem} is used to fill up quotes with an amount of product from another solution that also counts for the same solution, but doesn't carry any extra subsidy by itself */
class ZeroSubsidyItem {
    constructor(amount) {
        this.amount = amount;
        this.product = {
            isdeCode: 'none',
            subsidy: 0,
        };
    }
}
exports.ZeroSubsidyItem = ZeroSubsidyItem;
